export default {
  state: {
    keepAliveViews: [],
    routeScrollTops: {}
  },
  getters: {
    keepAliveViews: state => state.keepAliveViews,
    getRouteScrollTop: state => routeName => state.routeScrollTops[routeName] || 0
  },
  actions: {
    changeRouteAliveViews({ commit }, viewArr) {
      commit('changeRouteViews', viewArr);
    },
    setRouteScrollTop({ commit }, { routeName, scrollTop }) {
      commit('setRouteScrollTop', { routeName, scrollTop });
    }
  },
  mutations: {
    changeRouteViews(state, viewArr) {
      state.keepAliveViews = viewArr;
    },
    setRouteScrollTop(state, { routeName, scrollTop }) {
      state.routeScrollTops[routeName] = scrollTop;
    }
  }
};
